export enum SystemAuditValueEnum {
	MajorNotCompliant = 1,
	MinorNotCompliant = 2,
	OportunityForImprovement = 3,
	PositiveAspect = 4,
	Compliant = 5
}